module.exports = "<app-header></app-header>\n<div class=\"container\">\n<div class=\"row\">\n  <div class=\"col-md-12\">\n    <app-recipes></app-recipes>\n    <app-shopping-list></app-shopping-list>\n    </div>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = 154
// module chunks = 1